export default __webpack_public_path__ + "static/img5-4ac9c5f06c74479c70c4dee9eab96ffe.jpeg";